import { StoreSeller } from '../../models';
import { Spinner } from '../ui/Spinner';
import { CheckIcon } from '../ui/Icons';
import { EmptyState } from '../ui/EmptyState';
import { WhatsAppIcon } from '../../pages/checkout/CheckoutIcons';
import { buildStoreContactWhatsAppUrl } from '../../utils/whatsapp';

const NO_SELLER_MESSAGE = 'Olá! Quero fazer um pedido no site, mas não há vendedora disponível. Pode me ajudar?';

export function SellerPicker({
  sellers,
  loading,
  selectedSeller,
  onSelect,
}: {
  sellers: StoreSeller[];
  loading: boolean;
  selectedSeller: StoreSeller | null;
  onSelect: (seller: StoreSeller) => void;
}) {
  return (
    <div className="mb-5">
      <h2 className="text-sm font-bold text-chocolate-dark">Vendedora</h2>
      <p className="text-sm text-text-medium mt-0.5 mb-3">
        Quem te atendeu? A vendedora escolhida confirma frete e pagamento com você pelo WhatsApp.
      </p>

      {loading ? (
        <div className="flex justify-center py-6">
          <Spinner size="md" />
        </div>
      ) : sellers.length === 0 ? (
        <EmptyState
          title="Nenhuma vendedora disponível no momento."
          description="Você pode falar direto com a loja pelo WhatsApp."
          action={
            <a
              href={buildStoreContactWhatsAppUrl(NO_SELLER_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-lg border border-chocolate-dark text-chocolate-dark font-semibold px-4 py-2.5 min-h-[44px] hover:bg-champagne transition-colors"
            >
              <WhatsAppIcon className="w-5 h-5" />
              Falar com a loja no WhatsApp
            </a>
          }
        />
      ) : (
        <div className="flex flex-col gap-2">
          {sellers.map((seller) => {
            const isSelected = selectedSeller?.id === seller.id;
            return (
              <button
                key={seller.id}
                type="button"
                aria-pressed={isSelected}
                onClick={() => onSelect(seller)}
                className={[
                  'w-full text-left bg-white rounded-xl p-4 shadow-sm flex items-center justify-between gap-3 border-2 transition-all min-h-[56px]',
                  isSelected ? 'border-chocolate-dark' : 'border-transparent hover:border-champagne-dark',
                ].join(' ')}
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-champagne flex items-center justify-center text-chocolate-dark font-bold text-base flex-shrink-0">
                    {seller.name.charAt(0).toUpperCase()}
                  </div>
                  <p className="text-base font-semibold text-text-dark">{seller.name}</p>
                </div>
                {isSelected && <CheckIcon className="w-5 h-5 text-chocolate-dark flex-shrink-0" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
